const EntertainComponent = () => import('@/views/finance/entertain/EntertainView')

export default [
    {
        path:'/EntertainIndex',
        name:'EntertainComponent',
        component:EntertainComponent
    }
]